import React, {useState, useEffect, useMemo, useCallback} from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from './StaticIP.css';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import { FaInfoCircle,FaSync, FaSpinner } from 'react-icons/fa';
import Modal from '../../components/UI/Modal/Modal';
import Error from '../../components/UI/Error/Error';
import Success from '../../components/UI/Success/Success';
import Countdown from 'react-countdown-now';
import AddSubNetPanel from "./AddSubnet";


const StaticIP = (props) => {
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [subNets, setSubNets] = useState([]);
  const [selectedSubNet, setSelectedSubNet] = useState(null);
  const [configType, setConfigType] = useState('');
  const staticIp = props.staticIp?.staticIp;

  useEffect(() => {
    setSubNets(staticIp?.subnetDetails);
    setConfigType(staticIp.subnetHeader?.configType?.expectedResults?.customerPrefConfigType);
    if (staticIp?.subnetDetails) {
      setShowContent(true);
    }

 }, [staticIp?.subnetDetails, staticIp?.subnetHeader?.configType?.expectedResults?.customerPrefConfigType])


    const countdownRenderer = ({ seconds, completed }) => {
        if (completed) {
          // Render a completed state
          return <span>00</span>;
        } else {
          // Render a countdown
          return <span>{seconds}</span>;
        }
    }

    const successErrorResetHandler = () => {
      props.resetStaticIpsErrorSuccess();
    }

    const renderSubNetTable = () => {
      let prefConfigType = configType;
      if(configType === 'STATIC-DHCP'){
        prefConfigType = 'STATIC + DHCP';
      }else if(configType === 'STATIC-DHCP-NAT'){
        prefConfigType = 'STATIC + NAT';
      }else if(configType === 'STATIC-DHCP-NAT-WIRELESS'){
        prefConfigType = 'STATIC Wifi + NAT';
      }
      return (
        <div class={classes.contentContainerWithStaticIps}>
          <table style={{borderCollapse: 'collapse', width: '100%'}}>
            <thead>
              <tr style={{width: 'auto',  bordeBbottom: '2px solid #000'}}>
                <th id = 'staticIPSubnetID'
                  style={{
                    textAlign:'center',
                  color: 'black',
                  borderLeft: 'none',
                  borderRight: 'none',
                  textAlign: 'left',
                  // paddingRight: '30px',
                  paddingBottom: '10px',
                  cursor: 'pointer',
                  fontWeight: 200
                }}
                >Subnet ID</th>
                <th id = 'subNetBaseIPAdd' style={{  textAlign:'center', cursor: 'pointer',
                //  paddingRight: '40px',
                  fontWeight: 200, paddingBottom: '10px', }}
                >Base IP Address</th>
                <th id = 'subNetBlock' style={{ textAlign:'center', cursor: 'pointer',
                // paddingRight: '30px',
                fontWeight: 200, paddingBottom: '10px', }}
                 >Blocks Assigned</th>
                <th id = 'subNetConfig' style={{ textAlign:'center', cursor: 'pointer',
                 paddingRight: '0px',
                 fontWeight: 200, paddingBottom: '10px', }}
                   >Configuration Type</th>
                <th style={{ textAlign:'center', cursor: 'pointer', paddingLeft: '25px', fontWeight: 200, paddingBottom: '10px',}}
                    >
              {sessionStorage.getItem("userRoles")?.includes('staticIP') && <button id = 'staticIPAddSubnet' className={classes.successStaticLink}
                style={{ textDecoration: 'none' }}
                disabled={subNets?.length === 3}
                onClick={() => {
                  setSelectedSubNet(null);
                  setShowAddPanel(true)
                  }}>Add Subnet</button>}
                  </th>
              </tr>
            </thead>

            <tbody>
              {subNets?.map((subnet, index) => (
                <tr key={index}>
                  <td id = 'subNetId' style={{paddingTop: '15px',textAlign:'center'}}>{index + 1}</td>
                  <td id = 'subNetBaseAddress' style={{paddingTop: '15px',textAlign:'center' }} >{subnet.baseAddress}</td>
                  <td id = 'subNetLength' style={{paddingTop: '15px',textAlign:'center'}}>{
                  subnet.length == '30' ? '1' : subnet.length == '29' ? '5' : subnet.length == '28' ?'13' : subnet.length == '27' ? '29' : ''
                  }</td>
                  <td style={{paddingTop: '15px',textAlign:'center'}}>{prefConfigType}</td>
                  <td id = 'subNetViewEdit' style={{paddingTop: '15px',textAlign:'center', paddingLeft:'25px' }}>
                    {<span className={classes.successStaticLink}
                  onClick={() => {
                    setSelectedSubNet({
                      ...subnet,
                      id: `${index}`
                    })
                    setShowAddPanel(true)
                    }}>View/Edit</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    }

    const getContent = () => {
      return (
        showContent && (subNets?.length ? renderSubNetTable() :
        <div className={classes.contentContainer}>
          <div className= {classes.configureText}>
            <FaInfoCircle color="00BFFF" size={24} style={{ marginRight: '5px', marginLeft: '5px', marginTop: '10px' }} />
            <span id = 'staticIPtxt' className={classes?.StaticIpText}>Static IP has not been configured. Add Subnet to configure.</span>
          </div>
         {sessionStorage.getItem("userRoles")?.includes('staticIP') && <span id = 'addSubNet' className={classes.successStaticLink} onClick={() => setShowAddPanel(true)}>Add Subnet</span>}
        </div>)
      )
    }

  const saveSubnet = (data, ripKeyToggle) => {
      if(!ripKeyToggle){
        data.keyId = '';
        data.keyValue = '';
      }
      props.setStaticIp(data);
      setShowAddPanel(false);
      setSelectedSubNet(null);
      setTimeout(() => {
        props.getStaticIpsData();
      }, 1000)
    }

    const renderCountDownSpinner = () => {
        return (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <div id = 'subNetDetails'>
              <FaSpinner
                fontSize={'25px'}
                style={{ color: '#0073d1', marginRight: '5px' }}
                className={[
                  classes.fa,
                  classes.facircleonotch,
                  classes.faspin,
                  classes.fa3x,
                  classes.fafw,
                ].join(' ')}
              />
            </div>
            Please wait gathering Details{' '}
            <Countdown
              date={Date.now() + 10000}
              renderer={countdownRenderer}
              zeroPadTime={5}
            />
            s remaining.
          </div>
        );
    }

  return (
    <Box>
         <div className={classes.StaticIP}>
           <div className={classes.TitleArea}>
             <div className={classes.TitleLeft}>
             <h3 id='StaticIPText' className={classes.ComponentTitle}>Static IP </h3>
             </div>

             <div className={classes.TitleRight}>
            {!props.staticIpLoading &&  <button id = 'subNetGetData' className={classes.getDataLink} onClick={() => props.getStaticIpsData()} disabled={props.staticIpLoading} >{ showContent ?  <span  id ='subNetRefresh'>
                 <FaSync/> Refresh </span> : "Get Data"}
               </button> }
             </div>
           </div>
        {props.staticIpLoading ? renderCountDownSpinner() : getContent()}
           {showAddPanel &&
            <AddSubNetPanel
              saveSubnet={saveSubnet}
              selectedData={selectedSubNet}
              getDhcpReservations={props.getDhcpReservations}
              showPanel={showAddPanel}
              hidePanel={() => {
                setShowAddPanel(false)
                setSelectedSubNet(null)
              }
              }
              onAddIpReservation={props.onAddIpReservation}
              configType={configType}
              onDeleteStaticIpInfoDetails={props.onDeleteStaticIpInfoDetails}
              devicesByEquipment={props.devicesByEquipment}
            />
            }
      </div>

          <Modal
            show={props.upstreamError}
            modalClosed={() => props.resetUpstreamError()}
          >
            <Error id={'UpstreamError'} />
          </Modal>
          <Modal
            show={props.staticIpFail || props.staticIpDeleteFail || props.staticIpDeleteFailureMesssage  || (props.error && !showAddPanel && !props.upstreamError)}
            modalClosed={() => { successErrorResetHandler() }}
            showCloseIcon
          >
            <Error id={'StaticIpError'} customMsg={props.staticIpMesssage} />
          </Modal>
          <Modal
            show={props.staticIpSuccess || props.staticIpDeleteSuccess}
            modalClosed={() => { successErrorResetHandler() }}
          >
            <Success id={'StaticIpSuccess'} />
          </Modal>
       </Box>
  );

}

const mapStateToProps = (state) => ({
  staticIp : state.staticIp,
  staticIpSuccess: state.staticIp.staticIpSuccess,
  staticIpDeleteSuccess: state.staticIp.staticIpDeleteSuccess,
  staticIpFail: state.staticIp.staticIpFail,
  staticIpDeleteFail: state.staticIp.staticIpDeleteFail,
  staticIpMesssage: state.staticIp.staticIpFailureMesssage,
  staticIpLoading: state.staticIp.staticIpLoading,
  staticIpDeleteFailureMesssage: state.staticIp.staticIpDeleteFailureMesssage,
  error: state.dhcp.error,
  upstreamError: state.staticIp.upstreamError,
});

const mapDispatchToProps = (dispatch) => ({
    onDeleteStaticIpInfoDetails: (subnetId, callback) => {
      dispatch(actions.deleteStaticIpInfoDetails({ subnetId, callback }));
    },
    getStaticIpsData: () =>  dispatch(actions.getStaticIps()),
    setStaticIp: (data) =>  dispatch(actions.setStaticIp(data)),
    getDhcpReservations: () => dispatch(actions.getDhcpReservations()),
    onAddIpReservation: (ip, devMac, hostName, addToDHCP, callback, requestedFrom) => {
    dispatch(actions.addIpReservation(ip, devMac, hostName, addToDHCP, callback, requestedFrom))
    },
    resetStaticIpsErrorSuccess: () => {
      dispatch(actions.resetStaticIpsErrorSuccess());
      dispatch(actions.resetDhcpErrorSuccess())
    },
    resetUpstreamError: () => dispatch(actions.resetUpstreamError()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaticIP));